import React from 'react';

/**
 * Static page rendered when the current hostname's subdomain is in the
 * environment-level blocklist (VITE_BLOCKED_ORGS).  Mirrors the backend's
 * 404 "Invalid organization" response so users land on a sensible page
 * instead of the app's loading state when they hit a disabled org URL.
 *
 * No translations on purpose — this page renders before i18n is ready
 * for the would-be tenant context.
 */
const InvalidOrgPage = ({ subdomain }) => (
  <div
    style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f7f8fa',
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      padding: '24px',
    }}
  >
    <div
      style={{
        maxWidth: 480,
        width: '100%',
        backgroundColor: '#ffffff',
        borderRadius: 16,
        boxShadow: '0 6px 24px rgba(16, 24, 40, 0.08)',
        padding: '40px 32px',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          width: 56,
          height: 56,
          margin: '0 auto 20px',
          borderRadius: '50%',
          backgroundColor: '#fef2f2',
          color: '#b91c1c',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 28,
          fontWeight: 600,
        }}
        aria-hidden
      >
        !
      </div>
      <h1
        style={{
          margin: 0,
          fontSize: 22,
          fontWeight: 700,
          color: '#101828',
        }}
      >
        Invalid organization
      </h1>
      <p
        style={{
          marginTop: 12,
          marginBottom: 0,
          fontSize: 14,
          lineHeight: 1.6,
          color: '#475467',
        }}
      >
        {subdomain
          ? `The organization "${subdomain}" is not available on this environment.`
          : 'This URL is not configured for any organization on this environment.'}
      </p>
      <p
        style={{
          marginTop: 16,
          marginBottom: 0,
          fontSize: 13,
          color: '#667085',
        }}
      >
        If you believe this is a mistake, please contact your administrator.
      </p>
    </div>
  </div>
);

export default InvalidOrgPage;
